export default "__VITE_ASSET__DTLUnYQM__"